export default __webpack_public_path__ + "static/solid-5c40b27f3283001d8b537124a187370b.png";